module.exports = __webpack_public_path__ + "static/Lauren-Ducharme-Lab-bb13138f895b1edd114b857b85d9b52c.jpg";